import { EExamGroupStatus } from '@constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ItemStatus } from './StatusTitleItem.styles';

type StatusTitleItemProps = {
  status: EExamGroupStatus;
};

const INITIAL_STATES = [EExamGroupStatus.ANNOUNCED_DATE];

const PENDING_STATES = [EExamGroupStatus.PENDING_DATE, EExamGroupStatus.EXAM_IN_PROGRESS];

const FINISHED_STATES = [EExamGroupStatus.CLOSED_PERIOD, EExamGroupStatus.COMPLETED_PHASE];

const PUBLISHED_STATES = [EExamGroupStatus.DEFINITIVE_LIST, EExamGroupStatus.NOTES_PUBLISHED];

const OPEN_STATES = [
  EExamGroupStatus.OPEN_PERIOD,
  EExamGroupStatus.PROVISIONAL_LIST,
  EExamGroupStatus.COMPETITION_PHASE
];

export const StatusTitleItem: React.FC<StatusTitleItemProps> = ({ status }) => {
  const { t: tDefault } = useTranslation('DefaultTranslations');

  const theme = useTheme();

  const getStatusBackground = (examGroupStatus: EExamGroupStatus) => {
    if (INITIAL_STATES.includes(examGroupStatus)) {
      return theme.colors.purple4;
    }

    if (PENDING_STATES.includes(examGroupStatus)) {
      return theme.colors.black1;
    }

    if (OPEN_STATES.includes(examGroupStatus)) {
      return theme.colors.orange1;
    }

    if (FINISHED_STATES.includes(examGroupStatus)) {
      return theme.colors.black3;
    }

    if (PUBLISHED_STATES.includes(examGroupStatus)) {
      return theme.colors.green1;
    }

    return theme.colors.black1;
  };

  const getStatusColor = (examGroupStatus: EExamGroupStatus) => {
    if (INITIAL_STATES.includes(examGroupStatus)) {
      return theme.colors.purple7;
    }

    if (PENDING_STATES.includes(examGroupStatus)) {
      return theme.colors.black9;
    }

    if (OPEN_STATES.includes(examGroupStatus)) {
      return theme.colors.orange4;
    }

    if (FINISHED_STATES.includes(examGroupStatus)) {
      return theme.colors.black9;
    }

    if (PUBLISHED_STATES.includes(examGroupStatus)) {
      return theme.colors.green4;
    }

    return theme.colors.black9;
  };

  const getStatusBorderColor = (examGroupStatus: EExamGroupStatus) => {
    if (INITIAL_STATES.includes(examGroupStatus)) {
      return theme.colors.purple4;
    }

    if (PENDING_STATES.includes(examGroupStatus)) {
      return theme.colors.black3;
    }

    if (OPEN_STATES.includes(examGroupStatus)) {
      return theme.colors.orange4;
    }

    if (FINISHED_STATES.includes(examGroupStatus)) {
      return theme.colors.black4;
    }

    if (PUBLISHED_STATES.includes(examGroupStatus)) {
      return theme.colors.green4;
    }

    return theme.colors.black3;
  };

  return (
    <ItemStatus
      $color={getStatusColor(status)}
      $background={getStatusBackground(status)}
      $borderColor={getStatusBorderColor(status)}>
      {tDefault(status)}
    </ItemStatus>
  );
};
